<template>
  <div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="username"
        name="username"
        label="姓名"
        clearable
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="phone"
        name="phone"
        maxlength="11"
        clearable
        label="手机号"
        placeholder="手机号"
        :rules="[
          { required: true, message: '请填写您的手机号码！' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' },
        ]"
      />
      <van-field
        v-model="code"
        name="code"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <div class="sendBut">
            <van-button
              round
              color="rgb(249, 121, 0)"
              size="small"
              type="primary"
              @click.prevent="sendCode"
              >{{ tip }}</van-button
            >
          </div>
        </template>
      </van-field>
      <van-field
        v-model="remark"
        type="textarea"
        rows="3"
        name="remark"
        clearable
        label="备注"
        placeholder="备注"
        :rules="[{ required: true, message: '请填写备注' }]"
      />
      <div style="margin: 16px">
        <van-button
          color="rgb(249, 121, 0)"
          round
          block
          type="info"
          native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from "vant";
import URL from "@/api/api";
export default {
  data() {
    return {
      username: "",
      phone: "",
      code: "",
      remark: "",
      timer: null,
      count: 0,
      tip: "发送验证码"
    };
  },
  methods: {
    sendCode() {
      let data = {
        type: 5,
        phoneNumber: this.phone,
      };
      if (this.phone == "") {
        Toast("请输入手机号");
      } else {
        this.$fetchGet(URL.sendCode.url, data).then((res) => {
          let that=this
          if (!that.timer) {
            that.count = 60;
            that.timer = setInterval(() => {
              if (that.count >= 0 && that.count <= 60) {
                that.tip = that.count-- + "  " + "S";
              } else {
                that.tip = "发送验证码";
                clearInterval(that.timer);
                that.timer = that;
              }
            }, 1000);
          }
          if (res.data == true) {
            Toast('发送成功');
          } else {
            Toast('验证码5分钟之内有效');
          }
        });
      }
    },
    onSubmit(values) {
      let data = {
        agentPhone: this.$route.query.agentPhone || "",
        message: values.remark,
        name: values.username,
        phone: values.phone,
        verifyCode: values.code,
      };
      this.$fetchPost(URL.productConsult.url, data).then((res) => {
          if(res.data.code=='20000'){
            Toast(res.data.msg);
            setTimeout(function(){window.WeixinJSBridge.invoke("closeWindow",{},function(e){})},1000)
          }
      });
    },
  },
};
</script>

<style scoped>
.sendBut .van-button {
  width: 80px;
}
</style>
